import React from 'react';

function StudentCourseActiveDataButton({ selectFunction, studentData, prep }) {

    const dataInput = {
        totalAssessmentsEntries: studentData.active[prep].length,
        correct: (studentData.active[prep].filter(entry => entry.type === 'Recall').length > 0) ? studentData.active[prep].filter(entry => (entry.result === true || typeof entry.result === 'number' && entry.result === 0)).length + studentData.active[prep].filter(entry => entry.type === 'Recall').flatMap(entry => entry.recallItems).map(entry => entry.active).filter(entry => entry.correct === true).length / (studentData.active[prep].filter(entry => entry.type === 'Recall').flatMap(entry => entry.recallItems).map(entry => entry.active).length) * studentData.active[prep].filter(entry => entry.type === 'Recall').length : studentData.active[prep].filter(entry => (entry.result === true || typeof entry.result === 'number' && entry.result === 0)).length,
        incorrect: (studentData.active[prep].filter(entry => entry.type === 'Recall').length > 0) ? studentData.active[prep].filter(entry => (entry.result === false || typeof entry.result === 'number' && entry.result > 0)).length + studentData.active[prep].filter(entry => entry.type === 'Recall').flatMap(entry => entry.recallItems).map(entry => entry.active).filter(entry => entry.correct === false).length / (studentData.active[prep].filter(entry => entry.type === 'Recall').flatMap(entry => entry.recallItems).map(entry => entry.active).length) * studentData.active[prep].filter(entry => entry.type === 'Recall').length : studentData.active[prep].filter(entry => (entry.result === false || typeof entry.result === 'number' && entry.result > 0)).length,
        pending: (studentData.active[prep].filter(entry => entry.type === 'Recall').length > 0) ? studentData.active[prep].filter(entry => (entry.result === 'pending')).length + studentData.active[prep].filter(entry => entry.type === 'Recall').flatMap(entry => entry.recallItems).map(entry => entry.active).filter(entry => entry.correct === 'pending').length / (studentData.active[prep].filter(entry => entry.type === 'Recall').flatMap(entry => entry.recallItems).map(entry => entry.active).length) * studentData.active[prep].filter(entry => entry.type === 'Recall').length : studentData.active[prep].flat().filter(entry => (entry.result === 'pending')).length,
    }

    return (
        <button
            onClick={selectFunction}
            className={`py-1 px-2 m-1 rounded  text-columbia_blue-900 bg-dutch_white-300 hover:bg-dutch_white-400 w-[90%]`}>
            {prep}
            <div className={'w-full flex'}>

                {(dataInput.correct) ?

                    <div style={{width: `${dataInput.correct / dataInput.totalAssessmentsEntries * 100}%`}}
                         className={`bg-columbia_blue-700 border-dutch_white-100 rounded border-[1px] flex`}>
                        <div className={'grow'}/>
                        <svg
                            width={20}
                            height={30}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="black"
                            strokeWidth="2"
                            className={'mx-auto'}
                        >{/* Added fill to rectangle */}
                            <path d="M4 12 L8 16 L16 8" stroke="#f6f0e0" strokeWidth="1.5" fill="none"/>
                            {/* Centered the checkmark */}
                        </svg>
                        <p className={'text-[10px] my-auto text-dutch_white-100 font-bold'}>{Math.round(dataInput.correct / dataInput.totalAssessmentsEntries * 100)}%</p>
                        <div className={'grow'}/>
                    </div> : <></>
                }

                {(dataInput.incorrect) ?

                    <div style={{width: `${dataInput.incorrect / dataInput.totalAssessmentsEntries * 100}%`}}
                         className={`bg-burnt_sienna-600 rounded border-dutch_white-100 border-[1px] flex`}>
                        <div className={'grow'} />
                        <svg
                            width={20}
                            height={20}
                            viewBox="0 0 20 20"
                            fill="none"
                            stroke="black"
                            strokeWidth="2"
                            className={'mx-auto mt-[10px]'}
                        >
                            <path d="M5 2 L13 10 M13 2 L5 10" stroke="#f6f0e0" strokeWidth="1.5"
                                  fill="none"/>
                            {/* Centered the checkmark */}
                        </svg>
                        <p className={'text-[10px] my-auto text-dutch_white-100 font-bold'}>{Math.round(dataInput.incorrect / dataInput.totalAssessmentsEntries * 100)}%</p>
                        <div className={'grow'} />
                    </div> : <></>
                }

                {(dataInput.pending) ?
                    <div style={{width: `${dataInput.pending / dataInput.totalAssessmentsEntries * 100}%`}}
                         className={`bg-platinum-700 rounded border-dutch_white-100 border-[1px] overflow-hidden flex`}>
                        <div className={'grow'}/>
                        <svg
                            width={18}
                            height={30}
                            viewBox="0 0 8 8"  // Adjust the viewBox to be closer to the text size
                            fill="none"
                            stroke="#f6f0e0"
                            strokeWidth="0.2"
                            className={'mx-auto my-auto'}
                        >
                            <text
                                x="50%"
                                y="50%"
                                textAnchor="middle"
                                dominantBaseline="middle" // Centers text properly
                                fill="#f6f0e0"
                                fontSize="6"  // Adjust font size as needed
                            >
                                ?
                            </text>
                        </svg>
                        <p className={'text-[10px] my-auto text-dutch_white-100 font-bold'}>{Math.round(dataInput.pending / dataInput.totalAssessmentsEntries * 100)}%</p>
                        <div className={'grow'}/>

                    </div>
                    : <></>

                }</div>
        </button>);
}

export default StudentCourseActiveDataButton;